"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const loader_bg_svg_1 = __importDefault(require("../../assets/loader-bg.svg"));
const loader_fg_svg_1 = __importDefault(require("../../assets/loader-fg.svg"));
const Loader = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "autocomplete-input locating" }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "loader" }, { children: [(0, jsx_runtime_1.jsx)("img", { className: "loader-bg", src: loader_bg_svg_1.default, alt: "" }), (0, jsx_runtime_1.jsx)("img", { className: "loader-fg", src: loader_fg_svg_1.default, alt: "" })] })), t("autocomplete.findingCurrentLocation")] })));
};
exports.default = Loader;
